import { ListItemButton, Paper, styled } from "@mui/material";

export enum SnackbarSeverity {
    Success = 'success',
    Error = 'error',
    Warning = 'warning',
    Info = 'info'
  }
  
export const COLORS_CONFIG_PAGE = {
    primary: '#3965f0',
    background: '#fbfbfe',
    white: '#ffffff',
    dark: '#00000'
  };

export const COLORS_ADMIN_PAGE = {
    PRIMARY: '#0062ee',
    SECONDARY: '#6262ee',
    BACKGROUND: '#f5f5f5',
    CARD_BACKGROUND: '#e8eaf6',
    WHITE: '#ffffff',
    TEXT_SECONDARY: '#515e8e',
    HOVER: '#3965f0',
    DISABLED: '#cccccc',
    BORDER: '#ddddff',
    SELECTED: 'rgba(0, 0, 0, 0.08)',
    LIGHT_GRAY: '#fbfbfe',
    BLACK: '#000000'
};

export const SIZES_PAGE = {
    SIDEBAR_WIDTH: '25%',
    AVATAR_SIZE: 150,
    DIALOG_BUTTON_MIN_WIDTH: '40px',
};

export const ResizeHandle = styled('div')(({ theme }) => ({
  width: '4px',
  cursor: 'col-resize',
  height: 'calc(100vh - 64px)',
  backgroundColor: theme.palette.divider,
  '&:hover': {
    backgroundColor: COLORS_ADMIN_PAGE.PRIMARY,
  },
  userSelect: 'none',
}));

export const StyledSidebar = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'sidebarWidth'
})<{ sidebarWidth: string }>(({ theme, sidebarWidth }) => ({
  width: sidebarWidth, 
  height: 'calc(100vh - 64px)',
  overflow: 'auto',
  borderRight: '1px solid',
  borderColor: theme.palette.divider,
  flexShrink: 0, 
}));

export const StyledSelectedItem = styled(ListItemButton)(({ theme }) => ({
  backgroundColor: COLORS_CONFIG_PAGE.primary,
  color: COLORS_CONFIG_PAGE.white,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
  '& .MuiListItemText-primary': {
    fontWeight: 'bold',
  },
  '& .MuiListItemText-secondary': {
    color: COLORS_CONFIG_PAGE.white,
    opacity: 0.8,
  },
}));